var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNothingFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 379,
    viewBox: "0 0 530 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.83 293.113C316.158 293.113 395.058 236.806 395.058 167.349C395.058 97.8917 316.158 41.5854 218.83 41.5854C121.502 41.5854 42.6016 97.8917 42.6016 167.349C42.6016 236.806 121.502 293.113 218.83 293.113Z",
    fill: "#F5F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M409.072 344.473C453.502 344.473 489.519 339.471 489.519 333.3C489.519 327.129 453.502 322.126 409.072 322.126C364.642 322.126 328.625 327.129 328.625 333.3C328.625 339.471 364.642 344.473 409.072 344.473Z",
    fill: "#DFDFEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.455 351.081C320.72 351.081 385.787 345.534 385.787 338.691C385.787 331.848 320.72 326.301 240.455 326.301C160.19 326.301 95.123 331.848 95.123 338.691C95.123 345.534 160.19 351.081 240.455 351.081Z",
    fill: "#DFDFEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.24 119.082C268.24 119.082 265.551 134.709 245.954 154.825C245.954 154.825 243.789 152.142 247.536 141.024C251.282 129.907 267.123 115.296 268.24 119.082Z",
    fill: "#7E9E6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.24 119.082C268.24 119.082 250.606 131.709 245.954 154.825C245.954 154.825 245.053 162.752 247.766 169.621",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.842 131.705C220.842 131.705 225.789 127.953 217.278 118.58C209.194 109.676 200.634 101.692 183.904 98.7666C183.904 98.7666 188.954 121.453 199.855 126.86C210.756 132.268 220.842 131.705 220.842 131.705Z",
    fill: "#7E9E6E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.235 148.387C180.235 148.387 197.69 152.199 227.293 142.308C227.293 142.308 225.458 139.244 212.23 138.214C199.002 137.183 176.79 145.84 180.235 148.387Z",
    fill: "#7E9E6E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.234 148.387C180.234 148.387 201.176 137.288 227.292 142.308C227.292 142.308 229.979 142.982 232.714 146.64",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.702 164.219C194.702 164.219 213.381 176.528 242.983 166.639C242.983 166.639 237.226 156.212 223.999 155.181C210.771 154.15 191.256 161.673 194.702 164.219Z",
    fill: "#7E9E6E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M194.703 164.219C194.703 164.219 214.836 154.814 242.985 166.638C242.985 166.638 246.295 168.114 249.03 171.772",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M257.927 104.284C257.927 104.284 263.44 103.623 249.988 116.081C237.285 127.845 238.9 127.937 238.9 127.937C238.9 127.937 243.72 110.334 257.927 104.284Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.658 133.895C229.658 133.895 233.776 135.485 241.202 128.662C248.628 121.839 251.396 106.634 257.926 104.284C257.926 104.284 241.543 109.583 229.658 133.895Z",
    fill: "#7E9E6E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.66 186.139C248.284 169.248 236.655 150.058 220.842 131.706C220.842 131.706 216.957 126.613 203.461 113.41C189.965 100.206 183.904 98.7676 183.904 98.7676",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.992 105.094C255.992 105.094 240.403 111.904 229.659 133.895C227.057 139.223 230.17 143.439 232.715 146.64",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M398.15 287.398C398.15 287.398 385.121 297.024 355.098 289.96C355.098 289.96 355.177 285.139 365.952 280.502C376.728 275.865 399.854 282.934 398.15 287.398Z",
    fill: "#7E9E6E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M397.22 286.52C397.22 286.52 376.657 279.64 355.233 289.438C355.233 289.438 348.293 293.36 344.332 299.592",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M354.706 266.221C354.706 266.221 360.645 268.027 363.229 255.628C365.683 243.849 367.116 232.225 359.661 216.947C359.661 216.947 344.279 234.356 346.305 246.366C348.331 258.377 354.706 266.221 354.706 266.221Z",
    fill: "#7E9E6E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M398.868 270.869C398.868 270.869 403.45 274.007 385.132 274.509C367.835 274.984 368.989 276.118 368.989 276.118C368.989 276.118 384.197 266.051 398.868 270.869Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M358.117 274.507C358.117 274.507 360.169 278.419 370.246 278.182C380.323 277.946 392.41 268.331 398.87 270.869C398.87 270.869 383.056 264.051 358.117 274.507Z",
    fill: "#7E9E6E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M331.713 327.204C340.456 310.5 349.148 289.81 354.707 266.221C354.707 266.221 356.545 260.083 359.3 241.394C362.055 222.704 359.661 216.947 359.661 216.947",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M396.88 270.202C396.88 270.202 380.669 265.045 358.116 274.507C352.653 276.799 351.102 280.418 348.793 287.128",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.507 176.107C186.29 176.107 182.208 174.626 178.969 171.92L169.986 164.415C166.753 161.715 162.913 160.268 158.978 160.268H114.393C110.346 160.268 107.066 163.551 107.066 167.602V176.107V329.199C107.066 336.189 112.726 341.855 119.708 341.855H341.968C347.398 341.855 351.8 337.448 351.8 332.011V185.951C351.8 180.515 347.398 176.108 341.968 176.108H190.507V176.107Z",
    fill: "#2E2E3A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M351.799 332.836C351.799 332.836 336.673 304.43 335.16 301.168L293.821 216.854C292.782 214.613 290.539 213.18 288.071 213.18H134.451C128.867 213.18 120.789 210.25 116.501 206.667L110.302 201.489C107.069 198.788 103.229 197.341 99.2949 197.341H56.8638C52.3475 197.341 49.2795 201.934 51.0051 206.112L102.314 330.348C105.19 337.312 111.975 341.854 119.501 341.854H349.024C350.52 341.854 351.902 340.57 351.901 339.072L351.799 332.836Z",
    fill: "#0163FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M289.314 221.198L349.975 339.249",
    stroke: "#0163FF",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M264.318 241.541H212.065C210.64 241.541 209.314 240.823 208.549 239.639C206.783 236.904 208.776 233.324 212.065 233.324H264.318C265.743 233.324 267.069 234.042 267.834 235.226C269.6 237.962 267.607 241.541 264.318 241.541Z",
    stroke: "#0163FF",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M166.574 282.115L207.258 306.381",
    stroke: "#0163FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.838 280.945L174.273 306.527",
    stroke: "#0163FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M215.888 302.204C219.291 289.888 208.85 276.248 192.566 271.739C176.283 267.23 160.324 273.558 156.921 285.874C153.518 298.191 163.96 311.83 180.243 316.34C196.526 320.849 212.485 314.52 215.888 302.204Z",
    stroke: "#0163FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M397.028 176.187C398.004 171.965 393.516 166.701 389.268 167.531C385.809 168.206 384.087 169.036 383.532 169.22C382.446 169.578 374.338 169.05 373.41 170.402C372.738 171.382 376.967 172.513 379.672 172.782C380.23 172.837 380.394 173.566 379.918 173.861C377.259 175.511 371.967 178.865 371.517 179.694C370.914 180.804 368.165 185.123 368.939 185.602C369.714 186.082 372.056 183.924 373.578 182.393C375.101 180.862 379.549 179.56 379.549 179.56C379.549 179.56 371.815 187.332 370.795 189.487C369.277 192.695 373.682 191.288 373.682 191.288C372.992 193.101 376.605 192.704 377.459 192.02C379.146 190.668 384.361 184.369 384.376 185.011C384.391 185.653 378.989 192.516 379.536 194.119C380.084 195.723 382.269 193.711 383.532 192.02C384.797 190.329 388.509 185.602 388.509 185.602C388.509 185.602 392.726 182.52 396.247 177.196C396.275 177.154 397.016 176.237 397.028 176.187Z",
    fill: "#DB9C7F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M373.875 191.114L381.255 182.309",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M341.551 151.211L368.097 134.63C368.262 134.522 368.418 134.403 368.567 134.274L377.321 125.256C379.227 123.584 382.166 123.973 383.571 126.084L387.862 132.527C388.771 133.892 388.802 135.661 387.943 137.057L381.781 147.065C381.328 147.802 380.664 148.377 379.87 148.718C374.912 150.844 355.973 158.852 344.677 162.047C341.872 162.841 339.145 160.554 339.39 157.646L339.668 154.371C339.776 153.083 340.47 151.918 341.551 151.211Z",
    fill: "#9EC68A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M402.69 316.89L401.287 326.437C401.287 326.437 374.981 336.554 377.422 336.7C379.862 336.846 417.664 334.644 417.664 334.644L415.44 317.311L402.69 316.89Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M410.018 162.383C410.018 162.383 412.114 182.583 413.686 183.632C415.258 184.681 417.354 185.205 417.354 185.205L413.948 162.121L410.018 162.383Z",
    stroke: "#656575",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M451.557 148.5C451.557 148.5 462.219 170.236 459.124 182.347L400.02 174.208L401.253 151.626L451.557 148.5Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M453.18 152.903C453.18 152.903 444.826 168.392 428.84 169.63",
    stroke: "#656575",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M439.807 166.326C439.807 166.326 443.045 176.365 452.446 176.572",
    stroke: "#656575",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M400.021 174.208C400.021 174.208 384.186 230.646 383.775 248.815L395.345 318.811C395.345 318.811 406.382 324.305 417.878 319.866C418.349 319.684 412.05 283.562 411.607 246.37L444.652 177.15L400.021 174.208Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M459.384 179.979L457.056 248.085L483.085 319.288C483.085 319.288 472.193 328.5 458.435 320.116L430.177 252.317L433.075 202.986L420.76 195.52L418.926 174.154L459.384 179.979Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M413.645 167.531L426.192 176.996L444.18 156.891L400.486 163.14L411.178 177.334L413.645 167.531Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M464.693 315.738L462.423 323.975C462.423 323.975 445.828 341.995 448.273 341.995C450.719 341.995 477.97 330.841 477.97 330.841L474.477 313.679L464.693 315.738Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M449.434 158.134C449.434 158.134 456.611 175.798 451.44 249.893C451.44 249.893 469.568 289.836 478.968 321.429",
    stroke: "#656575",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M423.053 197.286L404.961 247.738L412.719 321.428",
    stroke: "#656575",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M344.149 161.172C344.149 161.172 344.5 162.939 340.592 164.288C336.685 165.637 334.385 165.209 334.385 165.209C334.385 165.209 325.619 154.858 325.23 154.492C324.841 154.126 325.503 150.146 328.096 148.552C329.671 147.584 335.778 149.162 340.333 150.551C343.509 151.519 345.468 154.703 344.935 157.983C344.726 159.272 344.464 160.468 344.149 161.172Z",
    fill: "#DB9C7F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M336.959 158.425C336.959 158.425 329.792 157.383 326.764 154.883C326.764 154.883 322.238 153.97 321.275 154.541C320.314 155.113 319.525 155.925 317.444 156.277C315.363 156.628 315.99 155.24 318.177 153.273C318.802 152.71 320.473 150.689 321.923 150.415C323.874 150.047 328.096 148.552 328.096 148.552L336.569 158.692",
    fill: "#DB9C7F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M334.387 165.209C334.387 165.209 331.481 167.034 330.459 166.984C329.437 166.935 328.471 166.325 328.221 164.644C328.221 164.644 322.809 165.638 324.524 161.538C324.524 161.538 321.255 161.007 321.168 158.871C321.168 158.871 318.264 157.423 318.899 155.101C319.534 152.779 328.645 152.989 328.645 152.989L338.312 157.903L334.387 165.209Z",
    fill: "#DB9C7F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M332.334 165.597C332.334 165.597 335.094 163.146 334.94 162.163C334.787 161.18 334.268 160.64 333.641 160.828C332.801 161.081 329.6 163.524 328.221 164.643",
    stroke: "#1A1C30",
    strokeWidth: 0.7799,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M324.524 161.538C324.524 161.538 331.877 160.389 331.945 159.298C332.013 158.208 331.499 156.769 329.964 157.075C328.138 157.439 322.904 158.694 321.168 158.66",
    stroke: "#1A1C30",
    strokeWidth: 0.7799,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M333.641 160.828C333.641 160.828 334.992 159.989 334.458 159.05C333.923 158.112 333.193 157.782 331.629 158.189",
    stroke: "#1A1C30",
    strokeWidth: 0.7799,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M321.02 155.585C321.02 155.585 321.422 155.062 321.99 154.526",
    stroke: "#1A1C30",
    strokeWidth: 0.7799,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M336.964 169.235L336.838 169.307C335.847 169.864 334.593 169.513 334.036 168.521L314.92 134.492L318.632 132.402L337.749 166.432C338.306 167.422 337.954 168.677 336.964 169.235Z",
    fill: "#2E2E3A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M324.37 139.961L325.975 142.817C326.41 143.592 326.213 144.529 325.535 144.911L322.068 146.863C321.39 147.245 320.488 146.925 320.053 146.152L318.379 143.172",
    fill: "#2E2E3A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M316.953 112.014C310.322 99.6983 302.01 91.2208 296.727 90.8244L296.902 89.6548L294.142 91.4566C289.397 94.6909 291.919 109.139 299.773 123.727C307.628 138.315 317.841 147.518 322.585 144.284L325.181 142.552L324.433 141.551C326.259 135.9 323.41 124.007 316.953 112.014Z",
    fill: "#2E2E3A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M324.977 142.702C330.037 140.063 327.932 126.001 320.277 111.294C312.622 96.5867 302.315 86.8037 297.256 89.4429C292.197 92.0822 294.301 106.144 301.956 120.851C309.611 135.558 319.918 145.341 324.977 142.702Z",
    fill: "#0163FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M317.093 111.999C323.486 123.872 325.995 135.317 322.699 137.565C319.403 139.812 311.549 132.01 305.156 120.138C298.764 108.265 296.255 96.8193 299.55 94.5718C302.847 92.3243 310.701 100.126 317.093 111.999Z",
    fill: "#D3DDF7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M336.959 158.425C336.959 158.425 329.792 157.383 326.764 154.883C326.764 154.883 322.238 153.97 321.275 154.541C320.314 155.113 319.525 155.925 317.444 156.277C315.363 156.628 315.99 155.24 318.177 153.273C318.802 152.71 320.473 150.689 321.923 150.415C323.874 150.047 328.096 148.552 328.096 148.552L336.569 158.692",
    fill: "#DB9C7F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M336.959 158.425C336.959 158.425 329.792 157.383 326.763 154.883C326.763 154.883 322.237 153.97 321.275 154.542C320.313 155.113 319.525 155.925 317.443 156.277",
    stroke: "#1A1C30",
    strokeWidth: 0.7799,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M317.093 111.999C310.701 100.126 302.847 92.3243 299.55 94.5718C299.29 94.7492 299.07 94.9902 298.881 95.2783C302.692 95.5102 309.357 102.754 314.917 113.081C320.805 124.016 323.394 134.583 321.192 137.941C321.762 137.976 322.269 137.857 322.698 137.565C325.995 135.317 323.485 123.871 317.093 111.999Z",
    fill: "#2E2E3A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M312.643 107.346C316.043 113.661 317.378 119.75 315.624 120.946C313.871 122.141 309.693 117.991 306.293 111.675C302.892 105.36 301.557 99.2707 303.311 98.0753C305.064 96.8799 309.242 101.03 312.643 107.346Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M439.794 127.673L434.52 108.835C432.584 101.92 429.192 95.5211 424.708 89.9149C416.766 79.9836 395.905 80.8871 395.905 80.8871L379.855 92.4489C379.806 92.4754 379.757 92.5027 379.708 92.53C370.258 97.7504 368.522 105.803 368.77 118.216L369.355 134.976L380.22 124.588L382.963 128.352C382.951 128.244 382.94 128.143 382.931 128.045L384.229 130.092L382.963 128.352C383.347 131.81 385.149 140.618 393.523 144.732L398.293 152.248L397.028 162.634C441.802 178.934 452.952 146.928 452.952 146.928L439.794 127.673Z",
    fill: "#9EC68A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M377.924 122.86L383.786 130.037C383.786 130.037 382.985 141.1 394.119 144.646",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M422.417 137.469L388.34 167.194C388.34 167.194 395.088 176.651 398.124 176.989L438.95 150.98",
    fill: "#9EC68A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M398.463 158.073C398.463 158.073 417.02 137.13 423.43 134.091",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M413.604 114.879C413.604 114.879 414.489 119.566 420.436 136.033",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M402.848 174.287C402.848 174.287 440.974 149.967 441.311 142.873C441.649 135.78 431.696 102.846 431.696 102.846",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M407.023 139.833C407.023 139.833 416.2 140.698 419.043 132.36",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M369.861 133.624C369.861 133.624 372.392 131.091 374.922 133.962",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M339.84 150.346L345.238 147.813C345.238 147.813 351.818 154.99 349.456 161.155L342.876 163.097C342.876 163.097 345.913 156.342 339.84 150.346Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M390.491 163.393C390.491 163.393 397.576 166.433 402.637 175.173L397.196 179.354C397.196 179.354 390.49 169.727 385.809 168.206L390.491 163.393Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M384.545 79.7925L406.897 81.4389C406.897 81.4389 407.744 93.748 394.246 104.603L388.184 98.7069L384.881 105.886C384.881 105.886 379.752 102.997 379.061 94.7054L380.15 84.6384L384.545 79.7925Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M395.907 80.8863C396.722 81.5821 397.109 82.6539 396.92 83.7098C396.202 87.7159 394.032 97.4122 389.682 98.6303C384.179 100.171 380.748 89.2933 380.748 89.2933L383.491 70.2925L395.907 80.8863Z",
    fill: "#DB9C7F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M378.477 85.3919L378.409 88.1586C378.358 88.1866 377.418 96.3541 380.16 96.6687C391.618 94.5948 392.339 83.7182 393.32 72.9243C393.32 72.9243 377.364 83.2369 378.477 85.3919Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M359.399 65.019C359.399 65.019 356.606 91.6612 373.139 96.2455C389.672 100.831 393.632 73.8383 393.062 64.5035C392.492 55.1688 388.336 51.6971 376.749 51.2787C359.605 50.6602 359.399 65.019 359.399 65.019Z",
    fill: "#DB9C7F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M374.252 77.8923C374.299 78.8512 373.844 79.6539 373.235 79.685C372.627 79.7161 372.095 78.9634 372.048 78.0045C372.001 77.0456 372.456 76.2429 373.065 76.2118C373.674 76.1815 374.205 76.9334 374.252 77.8923Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M376.068 72.984C376.068 72.984 370.606 75.3641 370.07 71.23",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M363.441 72.9946C363.441 72.9946 361.637 76.1305 359.562 74.7373",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M360.539 78.5645C360.539 78.5645 361.571 78.231 363.085 79.0314",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M376.729 88.5027C376.729 88.5027 378.218 87.0769 379.447 86.7524",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M365.553 81.6343C365.553 81.6343 364.604 83.7946 367.02 84.8315",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M359.206 70.7471C359.206 70.7471 359.486 62.9457 362.939 58.538C362.939 58.538 367.686 69.3402 388.143 71.5437L394.099 70.2908C394.099 70.2908 396.537 57.7823 387.992 52.8568C379.447 47.9313 366.368 50.6533 362.161 55.0823C355.029 62.5895 359.206 70.7471 359.206 70.7471Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M384.172 70.118L387.711 77.1174L390.214 69.2539L384.172 70.118Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M396.542 76.3905C395.523 80.1138 392.597 82.575 390.007 81.8883C387.418 81.2015 386.144 77.626 387.164 73.9028C388.183 70.1795 391.11 67.7182 393.699 68.405C396.289 69.0917 397.561 72.6672 396.542 76.3905Z",
    fill: "#DB9C7F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M393.944 73.1486C393.944 73.1486 391.031 70.6396 389.439 75.227C389.439 75.227 391.141 77.0349 390.067 78.4538C390.067 78.4538 391.744 78.8351 392.572 77.354",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M392.682 74.9035C392.682 74.9035 392.52 73.884 391.389 72.7212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M394.099 81.7623C394.099 83.1585 392.969 84.2902 391.574 84.2902C390.179 84.2902 389.049 83.1585 389.049 81.7623C389.049 80.3661 390.179 79.2344 391.574 79.2344C392.969 79.2344 394.099 80.3661 394.099 81.7623Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M387.021 56.1186C387.021 56.1186 390.129 39.8724 397.38 42.9832C404.63 46.0941 407.911 61.649 401.005 62.8588C394.1 64.0685 388.748 60.7849 388.748 60.7849L387.021 56.1186Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M387.107 60.7847C387.107 60.7847 399.106 70.8092 402.99 61.5624",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M432.45 202.602L418.561 194.755",
    stroke: "#656575",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M117.196 99.5507C132.203 99.96 144.62 111.994 145.484 126.999C145.992 135.822 142.577 143.851 136.829 149.516C135.979 150.353 135.585 151.546 135.783 152.722L137.942 165.51L124.66 157.763C123.903 157.322 123.012 157.159 122.154 157.333C118.907 157.989 115.467 158.109 111.922 157.572C98.8011 155.582 88.5646 144.708 87.3546 131.478C85.7419 113.844 99.8104 99.0762 117.196 99.5507Z",
    fill: "#D3DDF7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M115.052 138.827L114.97 131.85C115.987 131.602 116.914 131.279 117.753 130.879C118.592 130.481 119.328 130.02 119.96 129.496C120.592 128.974 121.121 128.389 121.548 127.741C121.974 127.095 122.296 126.4 122.517 125.657C122.737 124.914 122.847 124.129 122.847 123.303C122.847 122.12 122.558 121.005 121.981 119.959C121.404 118.914 120.578 118.067 119.506 117.42C118.434 116.773 117.156 116.449 115.671 116.449C114.077 116.449 112.599 116.891 111.238 117.771C109.877 118.652 108.839 120.151 108.125 122.271L107.383 121.775C108.015 119.766 109.074 118.225 110.558 117.151C112.043 116.077 113.733 115.541 115.63 115.541C117.253 115.541 118.675 115.885 119.899 116.573C121.122 117.261 122.077 118.19 122.765 119.36C123.452 120.53 123.796 121.844 123.796 123.303C123.796 124.405 123.611 125.436 123.24 126.4C122.869 127.363 122.345 128.244 121.672 129.042C120.999 129.841 120.181 130.535 119.218 131.127C118.256 131.72 117.17 132.167 115.96 132.469L115.879 138.827H115.052ZM114.557 144.029C114.557 143.671 114.654 143.376 114.846 143.142C115.038 142.908 115.3 142.791 115.63 142.791C116.014 142.791 116.289 142.901 116.455 143.121C116.62 143.342 116.702 143.644 116.702 144.029C116.702 144.36 116.612 144.648 116.434 144.896C116.254 145.144 115.986 145.268 115.629 145.268C115.271 145.268 115.003 145.157 114.824 144.937C114.646 144.717 114.557 144.415 114.557 144.029Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFound);
export default __webpack_public_path__ + "static/media/nothing-found.abd67b047e5ba5ec03bb38cf4952f533.svg";
export { ForwardRef as ReactComponent };